import React, { useState, useEffect, Fragment } from "react";
import { observer, useObservable } from "mobx-react-lite";
import Button from "../Button";
import QuoteSelector from "./QuoteSelector";
import SampleAttemptQuotables from "./SampleAttemptQuotables";

function QuoteItemPicker({
  companyId,
  sampleId,
  clientSuiteId,
  clientSpecificationId,
  matrixId,
  excludeQuoteItemIds,
  onAddQuoteItemIds,
  onCancel,
}) {
  const [attemptId, setAttemptId] = useState(null);
  const [selectedQuoteItemIds, setSelectedQuoteItemIds] = useState([]);

  const selectAttempt = (id) => {
    // clear selected quote items when new quote selected
    if (attemptId !== id) setSelectedQuoteItemIds([]);
    setAttemptId(id);
  };

  const addSelectedQuoteItems = () => {
    onAddQuoteItemIds(selectedQuoteItemIds);
    setSelectedQuoteItemIds([]);
  };

  return (
    <div
      className="basic-panel with-padding with-rounded-corners with-shadow"
      style={{ margin: 10, marginLeft: 0, marginRight: 0 }}
    >
      <div className="pull-right">
        <Button title="Close" small onClick={onCancel} style={{ marginBottom: 0 }} />
      </div>
      <h4>Select Price List to add additional tests from</h4>
      <QuoteSelector
        sampleId={sampleId}
        clientSuiteId={clientSuiteId}
        clientSpecificationId={clientSpecificationId}
        matrixId={matrixId}
        companyId={companyId}
        onSelect={selectAttempt}
      />
      {attemptId && (
        <Fragment>
          <hr />
          <p>
            <Button
              onClick={addSelectedQuoteItems}
              title={"Add " + selectedQuoteItemIds.length + " Selected Items"}
              primary
              disabled={selectedQuoteItemIds.length == 0}
            />
          </p>
          <SampleAttemptQuotables
            key={attemptId}
            attemptId={attemptId}
            sampleId={sampleId}
            clientSuiteId={clientSuiteId}
            clientSpecificationId={clientSpecificationId}
            selectedQuoteItemIds={selectedQuoteItemIds}
            disabledQuoteItemIds={excludeQuoteItemIds}
            onChangeQuoteItems={(ids) => setSelectedQuoteItemIds(ids)}
            companyId={companyId}
            matrixId={matrixId}
          />
          <p className="text-right small" style={{ marginTop: 10 }}>
            Individual item prices shown are the standard prices from the quote and do not
            include turnaround premiums that may apply to this sample.
          </p>
        </Fragment>
      )}
    </div>
  );
}

export default observer(QuoteItemPicker);
